export function normalizeXHandle(xHandle) {
  const safeHandle = String(xHandle || "").trim().replace(/^@/, "");
  if (!/^[A-Za-z0-9_]{1,15}$/.test(safeHandle)) return "";
  return safeHandle;
}

export function buildXProfileUrl(xHandle) {
  const safeHandle = normalizeXHandle(xHandle);
  if (!safeHandle) return "";
  return `https://x.com/${safeHandle}`;
}
